import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "font-awesome/css/font-awesome.min.css";
import "weather-icons/css/weather-icons.css";
import "prismjs/themes/prism.css";
import "../src/assets/scss/styles.scss";
import { ToastContainer, toast } from "react-toastify";
import { configureStore } from "./store";
import rootReducer from "./Redux/Reducers";
import rootSaga from "./Redux/Sagas";
import "react-calendar-timeline/style.css";
import { HotelProvider } from "./Common/HotelContext";

const store = configureStore(rootReducer, rootSaga);

ReactDOM.createRoot(document.getElementById("root")).render(
  <>
    <ToastContainer />
    <Provider store={store}>
      <HotelProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HotelProvider>
    </Provider>
  </>
);
